import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { publishBatteryArbitrage } from "./battery-arbitrage-cache"
import type {
  BatteryArbitrageDto,
  UpdateBatteryArbitrageSettingsDto,
} from "../dto/battery-arbitrage.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

export default function useUpdateBatteryProposalArbitrageSettings(): UseMutationResult<
  BatteryArbitrageDto,
  unknown,
  { proposalId: string; body: UpdateBatteryArbitrageSettingsDto }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      batteryProposalService.updateArbitrageSettings(proposalId, body),
    onSuccess: (arbitrage, { proposalId }) =>
      publishBatteryArbitrage(queryClient, proposalId, arbitrage),
  })
}
